import React from 'react';

import Icon, { Props } from './icon';

export const DeleteIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4,6.1c0.2-1.3,1.3-2.3,2.6-2.3c1.3,0,2.5,1,2.6,2.3H9.4z M7.7,6.1c0.2-2.2,2.1-4,4.3-4c2.3,0,4.2,1.8,4.3,4
	h2.2H20c0.5,0,0.9,0.4,0.9,0.8S20.5,7.8,20,7.8h-0.6V19c0,1.6-1.3,2.8-2.9,2.8h-9c-1.6,0-2.8-1.3-2.8-2.8V7.8H4
	C3.5,7.8,3.2,7.5,3.2,7S3.5,6.1,4,6.1h1.5H7.7z M8.5,7.8H6.4V19c0,0.6,0.5,1.1,1.2,1.1h9c0.6,0,1.1-0.5,1.1-1.1V7.8h-2.1H8.5z
	 M10,11.1c0.5,0,0.8,0.4,0.8,0.8v4c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8v-4C9.2,11.5,9.5,11.1,10,11.1z M14.9,12
	c0-0.5-0.4-0.8-0.9-0.8c-0.5,0-0.9,0.4-0.9,0.8v4c0,0.5,0.4,0.8,0.9,0.8c0.5,0,0.9-0.4,0.9-0.8V12z"
      />
    </Icon>
  );
};

export default React.memo(DeleteIcon);
